import { useContext, memo, PropsWithChildren } from 'react';
import DiagramTooltip from '../Generic/diagramTooltip';
import { TooltipContext } from '../Providers/tooltipContext';
import { HotSpot } from 'Guide/Schematics/Diagram/Providers/dataContext';
import { DiagramElementContext } from 'Guide/Schematics/Diagram/Providers/diagramElementContext';
import HotspotTooltipContent from './lightBoxTooltipContent';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';

function HotspotTooltip({
   data,
   children,
   visible,
}: PropsWithChildren<{
   data: HotSpot<iFixitHotSpotItem>;
   visible: boolean;
}>) {
   const tooltipContext = useContext(TooltipContext);
   const elementContext = useContext(DiagramElementContext);

   if (!visible) {
      return <>{children}</>;
   }

   const onHide = () => {
      tooltipContext.setOpenDataPointId(currentlyOpenId =>
         currentlyOpenId == data.id ? null : currentlyOpenId
      );
   };

   const appendTo = () => elementContext.SVGWrapperRef.current;

   return (
      <DiagramTooltip
         defaultIsOpen={visible}
         isOpen={visible}
         // @ts-expect-error TS(2322) FIXME: Type 'Element | null' is not assignable to type 's... Remove this comment to see the full error message
         content={visible ? <HotspotTooltipContent data={data} /> : null}
         isLazy={true}
         lazyBehavior="unmount"
         onClose={onHide}
         closeOnBlur={false}
         autoFocus={false}
         contentProps={{
            maxWidth: { base: 'calc(100vw - 20px)', sm: '600px' },
         }}
         // @ts-expect-error TS(2322) FIXME: Type '() => HTMLDivElement | null' is not assignab... Remove this comment to see the full error message
         appendTo={appendTo}
      >
         {children}
      </DiagramTooltip>
   );
}

export default memo(HotspotTooltip);
